import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { unlimitedAccountBanner as UnlimitedAccountBannerQuery } from './types/unlimitedAccountBanner';

const unlimitedAccountBannerQuery = gql`
  query unlimitedAccountBanner($accountId: Int!) {
    account(id: $accountId) {
      id
      isUnlimited
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<UnlimitedAccountBannerQuery>(
    unlimitedAccountBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
      },
    }
  );

  return Boolean(data?.account?.isUnlimited);
};
